/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, no-prototype-builtins */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import SubjectType from '@linc-technologies/linced-common/enums/subject-type';
import { byKeys } from '@linc-technologies/linced-common/utils/arrays';

export default class GoalsController extends Controller {
  subjectRoute = 'subject';
  queryParams = ['currentTab'];
  currentTab = 'Goals';

  @computed('model.subjects.@each.subjectTypeName')
  get subjectsByType() {
    let subjects = this.get('model.subjects'); // assuming 'model' is an array of subject objects

    return subjects.reduce((result, subject) => {
      let type = subject.subjectTypeName;

      if (!result[type]) {
        result[type] = [];
      }
      result[type].push(subject);
      return result;
    }, {});
  }

  // subjectTypeTabs provides a list of subject types to show tabs for, in a
  // stable order.
  @computed('subjectsByType')
  get subjectTypeTabs() {
    return SubjectType.values
      .filter(
        (subjectType) =>
          subjectType.value > 0 &&
          subjectType.hasContent &&
          this.subjectsByType.hasOwnProperty(subjectType.label),
      )
      .sort(byKeys('priority', 'label'));
  }
}
